<template>
  <b-overlay :show="loading">
    <div class="row">
      <div class="col-md-12">
        <b-row>
          <b-col class="col-md-8 text-left">
            <h2>Configurações de Agenda</h2>
          </b-col>
          <b-col class="text-right">
            <b-button variant="primary" size="sm" @click="voltar">
              <i class="fas fa-arrow-left"></i> Voltar
            </b-button>
            <b-button variant="primary" size="sm" @click="adicionar">
              <i class="fas fa-plus"></i> Adicionar Configuração
            </b-button>
          </b-col>
        </b-row>
        <b-card>
          <b-row>
            <b-table
              :items="configuracoes"
              :fields="fields"
              show-empty
              small
              empty-text="Nenhuma configuração encontrada"
            >
              <template #cell(actions)="row">
                <b-button
                  variant="primary"
                  size="sm"
                  class="mr-1"
                  @click="editar(row.item)"
                  title="Editar"
                >
                  <i class="fas fa-edit"></i>
                </b-button>
              </template>
            </b-table>
          </b-row>
        </b-card>
      </div>
    </div>

    <!-- Modal de configurações -->
    <b-modal
      v-model="modalConfiguracao"
      size="lg"
      title="Configuração de agenda"
    >
      <b-row>
        <b-col>
          <label class="mt-3" for="datepicker-dateformat2">Válido de</label>
          <b-form-datepicker
            :disabled="loadingModal"
            v-model="configuracao.valido_de"
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }"
            locale="pt-BR"
          ></b-form-datepicker>
        </b-col>
        <b-col>
          <label class="mt-3" for="">Até</label>
          <b-form-datepicker
            :disabled="loadingModal"
            v-model="configuracao.valido_ate"
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }"
            locale="pt-BR"
          ></b-form-datepicker>
        </b-col>
      </b-row>
      <b-row>
        <!-- <b-col>
          <label class="mt-3" for="">Valor do Km</label>
          <b-input-group prepend="R$" class="mb-2 mr-sm-2 mb-sm-0">
            <b-form-input
              v-model="configuracao.valor_km"
              placeholder="0,00"
              v-mask="['#,##', '##,##', '###,##', '####,##', '#####,##']"
            ></b-form-input>
          </b-input-group>
        </b-col>-->
        <b-col>
          <label class="mt-3" for="">Valor da Hospedagem</label>
          <b-input-group prepend="R$" class="mb-2 mr-sm-2 mb-sm-0">
            <b-form-input
              :disabled="loadingModal"
              v-model="configuracao.valor_hospedagem"
              placeholder="0,00"
              v-mask="['#,##', '##,##', '###,##', '####,##', '#####,##']"
            ></b-form-input>
          </b-input-group>
        </b-col>

        <b-col>
          <label class="mt-3" for="">Valor do Almoço</label>
          <b-input-group prepend="R$" class="mb-2 mr-sm-2 mb-sm-0">
            <b-form-input
              :disabled="loadingModal"
              v-model="configuracao.valor_almoco"
              placeholder="0,00"
              v-mask="['#,##', '##,##', '###,##', '####,##', '#####,##']"
            ></b-form-input>
          </b-input-group>
        </b-col>
        <b-col>
          <label class="mt-3" for="">Valor do Jantar</label>
          <b-input-group prepend="R$" class="mb-2 mr-sm-2 mb-sm-0">
            <b-form-input
              :disabled="loadingModal"
              v-model="configuracao.valor_jantar"
              placeholder="0,00"
              v-mask="['#,##', '##,##', '###,##', '####,##', '#####,##']"
            ></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>

      <template #modal-footer>
        <b-button
          :disabled="loadingModal"
          variant="primary"
          size="sm"
          @click="salvar"
        >
          <b-spinner
            small
            label="Spinning"
            v-if="loadingModal"
          ></b-spinner>
          <i class="fas fa-save" v-else></i> Salvar
        </b-button>
        <b-button
          :disabled="loadingModal"
          variant="secondary"
          size="sm"
          @click="modalConfiguracao = false"
        >
          Fechar
        </b-button>
      </template>
    </b-modal>
  </b-overlay>
</template>

<script>
export default {
  data() {
    return {
      loadingModal: false,
      loading: false,
      configuracoes: [],
      fields: [
        { key: "actions", label: "" },
        { key: "id", label: "Codigo" },
        { key: "periodo", label: "Período", class: "text-center" },
        {
          key: "valor_hospedagem",
          label: "Hospedagem",
          class: "text-center",
          formatter: (value) => {
            return value ? value.toString().replace(".", ",") : "";
          },
        },
        {
          key: "valor_almoco",
          label: "Almoço",
          class: "text-center",
          formatter: (value) => {
            return value ? value.toString().replace(".", ",") : "";
          },
        },
        {
          key: "valor_jantar",
          label: "Jantar",
          class: "text-center",
          formatter: (value) => {
            return value ? value.toString().replace(".", ",") : "";
          },
        },
        {
          key: "updated_at",
          label: "Atualização",
          formatter: (value) => {
            return value ? moment(value).format("DD/MM/YY HH:mm:ss") : "";
          },
        },
      ],
      modalConfiguracao: false,
      configuracao: {
        valido_de: "",
        valido_ate: "",
        valor_km: "",
        valor_hospedagem: "",
        valor_almoco: "",
        valor_jantar: "",
      },
    };
  },
  watch: {
    modalConfiguracao(newValue) {
      if (!newValue) {
        this.configuracao = {
          valido_de: "",
          valido_ate: "",
          valor_km: "",
          valor_hospedagem: "",
          valor_almoco: "",
          valor_jantar: "",
        };
      }
    },
  },
  mounted() {
    this.loadConfiguracoes();
  },
  methods: {
    voltar() {
      window.location.href = "/adm/agenda";
    },
    editar(item) {
      this.configuracao = item;
      this.modalConfiguracao = true;
    },
    adicionar() {
      this.modalConfiguracao = true;
    },
    loadConfiguracoes() {
      const vm = this;
      vm.loading = true;
      axios
        .get("/adm/agenda-parametros/get")
        .then((response) => {
          vm.configuracoes = response.data;
          vm.configuracoes.forEach((el) => {
            el.periodo =
              moment(el.valido_de).format("DD/MM/YY") +
              " - " +
              moment(el.valido_ate).format("DD/MM/YY");
          });
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          vm.loading = false;
        });
    },
    salvar() {
      const vm = this;
      vm.loadingModal = true;
      axios
        .post("/adm/agenda-parametros", vm.configuracao)
        .then((response) => {
          vm.loadConfiguracoes();
          vm.modalConfiguracao = false;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          vm.loadingModal = false;
        });
    },
    formatarData(data) {
      return moment(data).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/agenda/ListParametros.vue